import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SectionRow = styled.div`
  height: 44px;
  padding: ${Spacing.S12} ${Spacing.S16};
  background-color: ${Color.Black};
`
